import moment from "moment";

export const formatDate = (date: Date | undefined) => {
	if (!date) return undefined;
	return moment(date.toString()).format("MM/DD/YYYY");
};
